import AchievementsModal from "./AchievementsModal";

export default AchievementsModal;
